"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateReportFromView = void 0;
function generateReportFromView(view, title) {
    delete view.cleanLmss;
    return {
        title: title !== null && title !== void 0 ? title : view.title,
        type: view.type,
        state: JSON.stringify(Object.assign(Object.assign({}, view), { title: title !== null && title !== void 0 ? title : view.title, chartBox: view.chartBox, hideEmptyGroups: view.hideEmptyGroups })),
    };
}
exports.generateReportFromView = generateReportFromView;
exports.default = generateReportFromView;
